import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import Layout from '../components/Layout';

const Settings = () => {
  return (
    <Layout>
      <Container maxWidth={false} sx={{ width: '100%' }}>
        <Typography variant="h4" gutterBottom fontWeight={700} sx={{ mb: 1 }}>
          Settings
        </Typography>
        <Box sx={{ pb: 4 }}>
          <Outlet />
        </Box>
      </Container>
    </Layout>
  );
};

export default Settings;
